// extracted by mini-css-extract-plugin
export var modalFooter = "_p9-0";